/**
 * @generated SignedSource<<fe5dcf38798a42f155765370d5a23aa8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type BasicMetadata = {
  description?: string | null | undefined;
  title: string;
};
export type AclInputEntry = {
  actions: ReadonlyArray<string>;
  role: string;
};
export type CreateSeriesMutation$variables = {
  acl: ReadonlyArray<AclInputEntry>;
  metadata: BasicMetadata;
};
export type CreateSeriesMutation$data = {
  readonly createSeries: {
    readonly id: string;
  };
};
export type CreateSeriesMutation = {
  response: CreateSeriesMutation$data;
  variables: CreateSeriesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "acl"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "metadata"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "acl",
        "variableName": "acl"
      },
      {
        "kind": "Variable",
        "name": "metadata",
        "variableName": "metadata"
      }
    ],
    "concreteType": "Series",
    "kind": "LinkedField",
    "name": "createSeries",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateSeriesMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "CreateSeriesMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "15e5c228752b425f517015fc1e4e0813",
    "id": null,
    "metadata": {},
    "name": "CreateSeriesMutation",
    "operationKind": "mutation",
    "text": "mutation CreateSeriesMutation(\n  $metadata: BasicMetadata!\n  $acl: [AclInputEntry!]!\n) {\n  createSeries(metadata: $metadata, acl: $acl) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "41992655f02351d4aece65325d4bf7fc";

export default node;
